import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="state-cities"
// Listens to state select changes and loads cities via Turbo Stream
export default class extends Controller {
  static targets = ["stateSelect", "citySelect"]

  connect() {
    const stateId = this.stateSelectTarget.value
    if (!stateId) return

    get(`/states/${stateId}/cities`, {
      query: {
        city_select: this.citySelectTarget.id,
        selected_city_id: this.citySelectTarget.value
      },
      responseKind: "turbo-stream"
    })
  }

  async selectState(_event) {
    const stateId = this.stateSelectTarget.value
    if (!stateId) return

    get(`/states/${stateId}/cities`, {
      query: { city_select: this.citySelectTarget.id },
      responseKind: "turbo-stream"
    })
  }
}
